import Backbone from 'backbone'
import _ from 'lodash'
import mockSync from 'scoreboard/components/mock-sync'
import nestCollection from 'scoreboard/components/nest-collection'
import ChartDesignerSerie from './chart-designer-serie'
import ChartDesignerFeature from './chart-designer-feature'
import i18n from 'scoreboard/components/i18n'


const ChartDesignerStack = ChartDesignerFeature.extend({
	initialize: function (attr, opt = {}) {
		this.data = opt.data

		this.children = new SerieCollection(this.get('children'))
		nestCollection({
			parent: this,
			parentAttribute: 'children',
			children: this.children
		})
	},

	addChild(child, index) {
		let { id, tempId } = this.attributes
		if (id) {
			child.set('parentId', id)
		} else {
			child.set('tempParentId', tempId)
		}
		this.children.add(child, { at: index })
		this.reorderChildren()
	},

	removeChild(child) {
		child.unset('parentId')
		child.unset('tempParentId')
		this.children.remove(child)
		this.reorderChildren()
	},

	reorderChildren: function() {
		this.children.forEach((feature, index) => {
			feature.set({
				sortOrder: index,
				axis: this.get('axis')
			})
		})
	},

	getLabel: function() {
		const label = this.attributes.label
		return label || i18n.get('charts.stack.defaultTitle')
	}
})

ChartDesignerStack.TEMP_ID_PREFIX = 'st'

const SerieCollection = Backbone.Collection.extend({
	sync: mockSync,
	model: ChartDesignerSerie
})

export default ChartDesignerStack

ChartDesignerStack.__filename__ = 'charts/model/chart-designer-stack.js'
